<template>
  <div>
    <oil-form v-if='loading'
              title='СОЗДАТЬ ИМПОРТЕРА'
              :items='importer'
              :createForm='!id'
              :keys='keys'
              :formCallback='formCallback'
    >

      <template v-slot:Contend='{input}' v-if='id'>
        <v-container fluid>
          <v-btn outlined :disabled='!input.isEdit' dense color='primary' @click='contractsPlus' class='mb-5'>Добавить
            контракт
          </v-btn>
          <contend :item='importer.Contracts' :disabled='!input.isEdit' :data='importer'/>
          <!--          <test :disabled='!input.isEdit' :contracts='importer.Contracts' v-for='i of contractCounts' />-->
        </v-container>
      </template>

    </oil-form>
  </div>
</template>

<script>
import data from './settng/importer.json'
import {coreApi} from '~/services/core'
import {importerService} from '~/services/ImporterService'

export default {
  props: {
    id: String
  },
  data: () => ({
    importer: {
      Contracts: []
    },
    keys: data,
    name: false,
    loading: false

  }),
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    DatePicker: () => import('@/components/helper/form/oil.date.picker'),
    contend: () => import('./settng/contend.vue')
  },
  async created() {
    if (this.id) {
      const response = await coreApi.get(`importer?id=${this.id}`)
      this.importer = response.data

      this.contractCounts = this.importer.Contracts.length
      this.importer.Contracts = response.data.Contracts
    }

    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? importerService.update : importerService.create
    },
    message() {
      return this.id ? 'импортер удачно изменен' : 'импортер удачно создан'
    },
  },
  methods: {
    contractsPlus() {
      this.importer.Contracts.push({
        Number: '',
        StartDate: '',
        EndDate: '',
        Price: 0,
        Appendixes: [],
        Certifications: []
      })
    },

    async formCallback(data,input,form,func) {
      const response = await this.storeType(data)
      if (!response.data) return
      func(this.message)
      await this.$router.push('/importers/importer')
      // if (this.id) {
      //   await coreApi.put('importer', data)
      //   this.$router.push('/importers/importer')
      // } else {
      //   await coreApi.post('importer', data)
      //   this.$router.push('/importers/importer')
      // }


    }
  }
}
</script>